import React  from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip          from '@material-ui/core/Tooltip';

import { withStyles } from '@material-ui/core/styles';
import Button         from '@material-ui/core/Button';

import styles from './styles';

const StyledButton = props => {
  let { tooltip, text, loading, ...other } = props;

  if (tooltip) {
    return (
      <Tooltip title={tooltip}>
        <Button {...other}>
          { loading ? <CircularProgress color="primary" /> : text }
        </Button>
      </Tooltip>
    );
  } else {
    return (
      <Button {...other}>
        { loading ? <CircularProgress color="primary" /> : text }
      </Button>
    );
  }
}

export default withStyles(styles)(StyledButton);
